import { getTimestamp } from '../../../../../../../common/utils/timeUtil';
import { searchForIcon } from '../../../../../../components/elementIcon/elementIconService';
import globalLogger from '../../../../../../logger';

import {
    ICON_POPUP_SEARCH_SUBMIT,
    ICON_POPUP_SEARCH_SUCCESS,
    ICON_POPUP_SEARCH_FAILURE,
    ICON_POPUP_MODE_SET,
} from './iconsPopupConstants';

const logger = globalLogger.createChannel('workspace.toolbar');

export const setIconPopupMode = ({ mode, id }) => ({
    type: ICON_POPUP_MODE_SET,
    mode,
    id,
    timestamp: getTimestamp(),
});

export const findIcons =
    ({ query, id }) =>
    (dispatch) => {
        dispatch({ type: ICON_POPUP_SEARCH_SUBMIT, query, id });

        searchForIcon(query, 32)
            .then((response) => {
                const { icons } = response.data;
                dispatch({ type: ICON_POPUP_SEARCH_SUCCESS, query, icons });
            })
            .catch((err) => {
                logger.error('Failed to retrieve icons', err);
                dispatch({ type: ICON_POPUP_SEARCH_FAILURE, query });
            });
    };
